import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "small-home-page-card-title pca-red"
}
const _hoisted_2 = {
  key: 1,
  class: "not-secured-text mb-4 pca-red"
}
const _hoisted_3 = { class: "secondary-font summary-content px-4 pt-4 pb-2" }
const _hoisted_4 = { class: "d-flex justify-space-between align-center pca-red" }
const _hoisted_5 = { class: "mt-3" }
const _hoisted_6 = { style: {"font-size":"20px"} }
const _hoisted_7 = {
  key: 3,
  class: "d-flex justify-end mt-2",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentSummaryRowItemsByFormType = _resolveComponent("PaymentSummaryRowItemsByFormType")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass({ 'floating-mode': _ctx.isFloating })
  }, {
    default: _withCtx(() => [
      (!_ctx.isFloating)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_1, "Unpaid Items"))
        : _createCommentVNode("", true),
      (!_ctx.isFloating)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Registration is not secured until checkout/payment has been successfully processed."))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PaymentSummaryRowItemsByFormType, {
          formType: _ctx.FormType.PRIMARY_ENTRANT,
          paymentStatus: _ctx.PaymentStatus.UNPAID,
          paymentSummary: _ctx.userDataStore.getPaymentSummary[_ctx.FormType.PRIMARY_ENTRANT]
        }, null, 8, ["formType", "paymentStatus", "paymentSummary"]),
        _createVNode(_component_PaymentSummaryRowItemsByFormType, {
          formType: _ctx.FormType.CO_ENTRANT,
          paymentStatus: _ctx.PaymentStatus.UNPAID,
          paymentSummary: _ctx.userDataStore.getPaymentSummary[_ctx.FormType.CO_ENTRANT]
        }, null, 8, ["formType", "paymentStatus", "paymentSummary"]),
        _createVNode(_component_PaymentSummaryRowItemsByFormType, {
          formType: _ctx.FormType.CHILD,
          paymentStatus: _ctx.PaymentStatus.UNPAID,
          paymentSummary: _ctx.userDataStore.getPaymentSummary[_ctx.FormType.CHILD]
        }, null, 8, ["formType", "paymentStatus", "paymentSummary"]),
        _createVNode(_component_PaymentSummaryRowItemsByFormType, {
          formType: _ctx.FormType.GUEST,
          paymentStatus: _ctx.PaymentStatus.UNPAID,
          paymentSummary: _ctx.userDataStore.getPaymentSummary[_ctx.FormType.GUEST]
        }, null, 8, ["formType", "paymentStatus", "paymentSummary"]),
        (new Date(_ctx.appDataStore.getEventDetails.REGISTRATION_OPEN).getTime() < Date.now())
          ? (_openBlock(), _createBlock(_component_PaymentSummaryRowItemsByFormType, {
              key: 0,
              formType: _ctx.FormType.EVENT,
              paymentStatus: _ctx.PaymentStatus.UNPAID,
              paymentSummary: _ctx.getEventPaymentSummary
            }, null, 8, ["formType", "paymentStatus", "paymentSummary"]))
          : _createCommentVNode("", true),
        (new Date(_ctx.appDataStore.getEventDetails.REGISTRATION_OPEN).getTime() < Date.now())
          ? (_openBlock(), _createBlock(_component_PaymentSummaryRowItemsByFormType, {
              key: 1,
              formType: _ctx.FormType.MEAL,
              paymentStatus: _ctx.PaymentStatus.UNPAID,
              paymentSummary: _ctx.userDataStore.getPaymentSummary[_ctx.FormType.MEAL]
            }, null, 8, ["formType", "paymentStatus", "paymentSummary"]))
          : _createCommentVNode("", true),
        (new Date(_ctx.appDataStore.getEventDetails.REGISTRATION_OPEN).getTime() < Date.now())
          ? (_openBlock(), _createBlock(_component_PaymentSummaryRowItemsByFormType, {
              key: 2,
              formType: _ctx.FormType.CAR,
              paymentStatus: _ctx.PaymentStatus.UNPAID,
              paymentSummary: _ctx.userDataStore.getPaymentSummary[_ctx.FormType.CAR]
            }, null, 8, ["formType", "paymentStatus", "paymentSummary"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mt-3" }, "Balance Due", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userDataStore.getFormattedBalanceDue), 1)
          ])
        ]),
        (_ctx.props.showPayBalanceBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_v_btn, {
                disabled: _ctx.userDataStore.getPrimaryEntrantDetails === null,
                flat: "",
                class: "my-2 primary-font",
                color: "pca-red",
                style: {"font-size":"14px","font-weight":"600","height":"32px"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push(_ctx.RouteName.CHECKOUT)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.userDataStore.getBalanceDue !== 0 ? 'Pay Balance' : 'Secure Registration'), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}